// extracted by mini-css-extract-plugin
export var container = "_dz-0";
export var icon = "_dz-1";
export var text = "_dz-2";